import { HAPPINESS_DECAY_MS, PLAY_AMOUNT } from './constants';

const clamp = (n: number, lo: number, hi: number): number => Math.min(hi, Math.max(lo, n));

export function tickHappiness(value: number, dtMs: number, decayMul = 1, decayMs = HAPPINESS_DECAY_MS): number {
  if (dtMs <= 0) return clamp(value, 0, 100);
  const drop = (dtMs / decayMs) * decayMul;
  return clamp(value - drop, 0, 100);
}

export function play(value: number): number {
  return clamp(value + PLAY_AMOUNT, 0, 100);
}
